import * as XLSX from 'xlsx';

// Parse the first sheet of an Excel/CSV file into an array of row objects
// (header row -> keys). Used to import suppliers or VAT invoices into IndexedDB.
export async function parseSpreadsheet(file: File): Promise<Record<string, any>[]> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: 'array' });
  const ws = wb.Sheets[wb.SheetNames[0]];
  return XLSX.utils.sheet_to_json<Record<string, any>>(ws, { defval: '' });
}
